import { FieldProps } from "@rjsf/utils";

import { RanaTabs } from "@/lib/rana-tabs";

import { useProcessRunFormTabs } from "./hooks/use-process-run-form-tabs";

export function ProcessRunFormTabs(props: FieldProps) {
  const { tabs, defaultTab, onTabChange } = useProcessRunFormTabs(props);

  if (!tabs) return null;

  return (
    <RanaTabs
      defaultTab={defaultTab}
      tabPanelProps={{ mt: 4 }}
      onChange={onTabChange}
      tabProps={{ w: "full" }}
      tabs={tabs}
    />
  );
}
